import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';

import Modal from '../../../../components/Modal';
import AlertMessage from '../../../../components/AlertMessage';
import LoadMask from '../../../../components/LoadMask';
import Button from '../../../../components/Button';
import RFTextField from '../../../../components/RFTextField';
import { required, validEmail } from '../../../../utils/validators';
import { forgotPassword } from '../../../../redux/auth';
import { getForgotPasswordUI } from '../../../../redux/selectors';

import './styles.css';

class LoginForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSuccessMessage: false,
    };
  }

  _submit = ({ email }) => {
    this.props.dispatch(forgotPassword(email)).then(
      () => {
        this.setState({ showSuccessMessage: true });
      },
      // error
      () => {},
    );
  };

  _renderContent = () => {
    const { handleSubmit, ui, invalid } = this.props;

    if (this.state.showSuccessMessage) {
      return (
        <AlertMessage
          box
          success
          message="Uma nova senha foi enviada para o e-mail informado."
        />
      );
    }

    return (
      <div>
        <p className="LoginForgotPassword__text">
          Informe seu e-mail de acesso à Plataforma Luft para que possamos lhe
          enviar as instruções de recuperação de senha.
        </p>
        <form onSubmit={handleSubmit(this._submit)}>
          <Field
            name="email"
            validate={[required, validEmail]}
            floatingLabelText="E-mail"
            fullWidth
            component={RFTextField}
          />
          {ui.error && <AlertMessage error box message={ui.error} />}
          <div className="LoginForgotPassword__action">
            <Button
              type="submit"
              disabled={invalid || ui.isFetching}
              text="Enviar"
              skin="primary"
            />
          </div>
        </form>
      </div>
    );
  };

  render() {
    const { ui } = this.props;

    return (
      <Modal title="Recuperar senha" size="small" {...this.props}>
        {this._renderContent()}
        {ui.isFetching && <LoadMask text="Enviando solicitação..." />}
      </Modal>
    );
  }
}

// redux

const mapStateToProps = state => ({
  ui: getForgotPasswordUI(state),
  initialValues: {
    email: '',
  },
});

export default connect(mapStateToProps)(reduxForm({ form: 'forgotPassword' })(LoginForgotPassword));
